/**
 * The point categories and modifiers shown in the Rules section of the
 * Coming Soon page.
 *
 * PLACEHOLDER VALUES from the 2026-09 wireframes. The point amounts here are
 * the designer's illustrative numbers, not the certified scoring rules —
 * those live in Documentation/04 (FR-030 onward) and the campaign constants.
 * Replace the amounts once Game Ops signs off on the final table; the titles
 * and descriptions are messages (`pages.home.cs.rules.categories.<key>`).
 */
export interface ScoringCategory {
  key: string;
  /** Icon file under /cs, exported from the wireframe. */
  icon: string;
  points: number;
}

export const SCORING_CATEGORIES: readonly ScoringCategory[] = [
  { key: 'crafting', icon: 'hammer', points: 120 },
  { key: 'community', icon: 'users', points: 100 },
  { key: 'streamed', icon: 'camera', points: 180 },
  { key: 'regionalCrown', icon: 'crown', points: 800 },
  { key: 'decrees', icon: 'scroll', points: 600 },
  { key: 'eliteFirsts', icon: 'trophy', points: 1000 },
  { key: 'mostWanted', icon: 'star', points: 750 },
  { key: 'bounty', icon: 'target', points: 500 },
  { key: 'factionWar', icon: 'flag', points: 400 },
  { key: 'pvp', icon: 'swords-rule', points: 300 },
  { key: 'dungeons', icon: 'castle', points: 250 },
  { key: 'progression', icon: 'shield', points: 150 },
];

export interface ScoringModifier {
  key: string;
  icon: string;
  tone: 'bonus' | 'penalty' | 'neutral';
}

export const SCORING_MODIFIERS: readonly ScoringModifier[] = [
  { key: 'eventBonus', icon: 'plus', tone: 'bonus' },
  { key: 'penalty', icon: 'minus', tone: 'penalty' },
  { key: 'manual', icon: 'wrench', tone: 'neutral' },
];

/** Social links for the footer. Empty href = rendered disabled until known.
 *  Order matches Figma FOOTER (`1859:6969` desktop / `1859:7079` mobile).
 *  The globe is the official AION 2 site and is drawn larger than the other marks. */
export const SOCIAL_LINKS: ReadonlyArray<{ key: string; icon: string; href: string }> = [
  { key: 'aion', icon: 'aion', href: 'https://aion2.plaync.com/en-us/index?redirect=false' },
  { key: 'youtube', icon: 'youtube', href: 'https://www.youtube.com/@Aion2Official' },
  { key: 'twitch', icon: 'twitch', href: 'https://www.twitch.tv/aion2official' },
  { key: 'discord', icon: 'discord', href: 'https://discord.gg/aion2official' },
  { key: 'tiktok', icon: 'tiktok', href: 'https://www.tiktok.com/@aion2official' },
  { key: 'instagram', icon: 'instagram', href: 'https://www.instagram.com/aion2official' },
  { key: 'facebook', icon: 'facebook', href: 'https://www.facebook.com/aion2official/' },
  { key: 'twitter', icon: 'twitter', href: 'https://x.com/Aion2Official' },
];

/** Official AION 2 Steam store page (Figma Coming Soon footer CTA). */
export const STEAM_WISHLIST_URL = 'https://store.steampowered.com/app/3393110/AION_2/';

/** Coming Soon footer legal bar. Order matches existing Privacy / Terms / Support labels. */
export const LEGAL_LINKS: ReadonlyArray<{ key: 'privacy' | 'terms' | 'support'; href: string }> = [
  { key: 'privacy', href: 'https://www.plaync.com/policy/privacy/en' },
  { key: 'terms', href: 'https://www.plaync.com/policy/service/game_en' },
  { key: 'support', href: 'https://help.plaync.com/faq/aion2global' },
];
